import { domain } from 'modules/data';
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { executeReport } from '../../../../resources/actions';
import { getActiveReport, getActiveReportConfig } from '../../../../resources/selectors/pageSelectors';

export const useReportData = () => {
    const dispatch = useDispatch();

    const reportType = domain.ReportType.LineItem;

    const report = useSelector(getActiveReport);
    const reportConfig = useSelector(getActiveReportConfig);

    const handleReportPageChange = useCallback(
        (nextIndex: number) => {
            dispatch(
                executeReport({
                    pageIndex: nextIndex,
                })
            );
        },
        [dispatch]
    );

    useEffect(() => {
        dispatch(executeReport());
    }, [dispatch, reportConfig?.id]);

    return { report, reportType, reportConfig, handleReportPageChange };
};
